// Routing paths
const Path = {
    HOME: "/",
    DESCRIPTION:"/description",
    CREATEPROPOSAL:"/createProposal"
  };
  
  export default Path;